import moment from 'moment';

export function formatTimestamp(time) {
  return moment(time).format(`lll`);
}

export function formatDatestamp(time) {
  return moment(time).format('ddd, ll')
}